module.exports = __webpack_public_path__ + "static/media/bank_transfer.3f5d0daa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Input/bank_transfer.png
 ** module id = 173
 ** module chunks = 0
 **/